import styled from "@emotion/styled"

const ArticleContentBold = styled.b`
  font-weight: 600;
  line-height: 24px;
`

export default ArticleContentBold
